export const tr = {
    perWeek: 'haftada'
};
